// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* From: http://codepen.io/Thomas-Lebeau/pen/csHqx  */

.spinner {
  width: 100px;
}
.spinner input {
  text-align: right;
}
.input-group-btn-vertical {
  position: relative;
  white-space: nowrap;
  width: 1%;
  vertical-align: middle;
  display: inline-block;
}
.input-group-btn-vertical > .btn {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%;
  /*padding: 8px;*/
  margin-left: -1px;
  position: relative;
  border-radius: 0;
}
.input-group-btn-vertical > .btn:first-child {
  border-top-right-radius: 4px;
}
.input-group-btn-vertical > .btn:last-child {
 /* margin-top: -2px;*/
  border-bottom-right-radius: 4px;
}
.input-group-btn-vertical span{
  position: absolute;
  top: 0;
  left: 8px;
}`, "",{"version":3,"sources":["webpack://./assets/style/spinner.css"],"names":[],"mappings":";AACA,qDAAqD;;AAErD;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;CACC,qBAAqB;EACpB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX","sourcesContent":["\r\n/* From: http://codepen.io/Thomas-Lebeau/pen/csHqx  */\r\n\r\n.spinner {\r\n  width: 100px;\r\n}\r\n.spinner input {\r\n  text-align: right;\r\n}\r\n.input-group-btn-vertical {\r\n  position: relative;\r\n  white-space: nowrap;\r\n  width: 1%;\r\n  vertical-align: middle;\r\n  display: inline-block;\r\n}\r\n.input-group-btn-vertical > .btn {\r\n  display: block;\r\n  float: none;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  /*padding: 8px;*/\r\n  margin-left: -1px;\r\n  position: relative;\r\n  border-radius: 0;\r\n}\r\n.input-group-btn-vertical > .btn:first-child {\r\n  border-top-right-radius: 4px;\r\n}\r\n.input-group-btn-vertical > .btn:last-child {\r\n /* margin-top: -2px;*/\r\n  border-bottom-right-radius: 4px;\r\n}\r\n.input-group-btn-vertical span{\r\n  position: absolute;\r\n  top: 0;\r\n  left: 8px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
